var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImgUsdt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#3B9977"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8729 9.65556V7.46173H18.7185V4H5.26788V7.46173H10.1271V9.65556C6.05619 9.85723 3 10.699 3 11.7073C3 12.7157 6.05278 13.5522 10.1271 13.7591V21H13.8729V13.7591C17.9438 13.5592 21 12.7175 21 11.7073C21 10.6972 17.9472 9.85723 13.8729 9.65556ZM12 13.1033C7.59194 13.1033 4.01816 12.4018 4.01816 11.5565C4.01816 10.8288 6.62145 10.2185 10.1237 10.0554V12.5333C10.7264 12.5614 11.353 12.5772 11.9966 12.5772C12.6402 12.5772 13.2701 12.5614 13.8695 12.5333V10.0554C17.3717 10.2185 19.975 10.8288 19.975 11.5565C19.9818 12.4106 16.4081 13.1033 12 13.1033Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgUsdt);
export default __webpack_public_path__ + "static/media/imgUsdt.8594bff1c56320b5606ab256059a1a6c.svg";
export { ForwardRef as ReactComponent };